import { Text, TextType } from 'ui-components/components/text';

import { noteCountAndGiftText } from '../../../../services/order-note-service';
import { OrdersSidebarSectionHeaderChip } from '../orders-sidebar-section-header-chip';
import { messages } from './messages';
import sectionStyle from '../orders-sidebar-section.module.less';

/**
 * @param {object} props
 * @param {object[]} props.notes
 * @returns {JSX.Element}
 */
export const NotesSectionHeaderContent = ({ notes }) => {
  return (
    <div className={sectionStyle['orders-sidebar-section-header-title-and-count']}>
      <Text textType={TextType.H4} value={messages.notes} />
      <OrdersSidebarSectionHeaderChip>{noteCountAndGiftText(notes, true)}</OrdersSidebarSectionHeaderChip>
    </div>
  );
};
